<form (ngSubmit)="updateInterfaceSettings()" [formGroup]="form">

  <div class="form-group">
    <label i18n for="theme">Theme</label>

    <my-select-options inputId="theme" formControlName="theme" [items]="availableThemes"></my-select-options>
  </div>

  <input *ngIf="!reactiveUpdate()" type="submit" class="peertube-button primary-button" i18n-value value="Save interface settings" [disabled]="!form.valid">
</form>
